import * as React from 'react'

import { cn } from '@/lib/utils'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // Match visual style of Input but keep a minimum height
        'flex min-h-[60px] w-full rounded-lg border border-border bg-[#0b0b0b] px-3 py-2 text-sm ring-offset-background placeholder:text-[#555] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-card-foreground disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'

export { Textarea }
